import React from 'react';

const MasterContext = React.createContext({

    // Datos afinidades
    affinityName: null,
    responsableName: null,
    link: null,
    adviserName: null,
    adviserDNI: null,
    affinitiesInfo: null,
    unidadesNegocioOptions: null,
    open: false,
    advisers: null,
    reload: false,
    modified: false,
    isReady: false

});

export default MasterContext;